import { createContext, useEffect, useState } from "react";

export const MasajidContext = createContext(null);

const FAVOURITES_KEY = "mis-masajid-favourites";
const MY_MASJID_KEY = "mis-masajid-my-masjid";
const MY_LANGUAGE_KEY = "mis-language-preference";

export const MasajidProvider = ({ children }) => {
  const [masajid, setMasajid] = useState([]);
  const [favourites, setFavourites] = useState(() => {
    try {
      const stored = localStorage.getItem(FAVOURITES_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (err) {
      console.error("Failed to load favourites:", err);
      return [];
    }
  });
  const [myMasjid, setMyMasjid] = useState(() => {
    try {
      const stored = localStorage.getItem(MY_MASJID_KEY);
      return stored || null;
    } catch (err) {
      console.error("Failed to load my masjid:", err);
      return null;
    }
  });
  const [language, setLanguage] = useState(() => {
    try {
      const stored = localStorage.getItem(MY_LANGUAGE_KEY);
      return stored || "english";
    } catch (err) {
      return "english";
    }
  });
  const [isLanguageSet, setIsLanguageSet] = useState(() => {
    try {
      return localStorage.getItem(MY_LANGUAGE_KEY) !== null;
    } catch (err) {
      return false;
    }
  });

  useEffect(() => {
    fetch(`/api/v1/masjid/all`)
      .then((res) => res.json())
      .then((data) => {
        setMasajid(data);
      })
      .catch((err) => console.error("Failed to fetch masajid:", err));
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(FAVOURITES_KEY, JSON.stringify(favourites));
    } catch (err) {
      console.error("Failed to save favourites:", err);
    }
  }, [favourites]);

  useEffect(() => {
    try {
      if (myMasjid) {
        localStorage.setItem(MY_MASJID_KEY, myMasjid);
      } else {
        localStorage.removeItem(MY_MASJID_KEY);
      }
    } catch (err) {
      console.error("Failed to save my masjid:", err);
    }
  }, [myMasjid]);

  useEffect(() => {
    if (isLanguageSet) {
      localStorage.setItem(MY_LANGUAGE_KEY, language);
    }
  }, [language, isLanguageSet]);

  const addFavourite = (username) => {
    setFavourites((prev) => {
      if (!prev.includes(username)) {
        return [...prev, username];
      }
      return prev;
    });
  };

  const removeFavourite = (username) => {
    setFavourites((prev) => prev.filter((u) => u !== username));
  };

  const toggleFavourite = (username) => {
    if (favourites.includes(username)) {
      removeFavourite(username);
    } else {
      addFavourite(username);
    }
  };

  const isFavourite = (username) => favourites.includes(username);

  const getFavourites = () => {
    return favourites
      .map((username) => masajid.find((m) => m.username === username))
      .filter(Boolean);
  };

  const setMyMasjidUsername = (username) => {
    setMyMasjid(username);
  };

  const unsetMyMasjid = () => {
    setMyMasjid(null);
  };

  const getMyMasjid = () => myMasjid;

  const isMyMasjid = (username) => myMasjid === username;

  const changeLanguage = (lang) => {
    setLanguage(lang);
    setIsLanguageSet(true);
  };

  return (
    <MasajidContext.Provider
      value={{
        masajid,
        language,
        isLanguageSet,
        changeLanguage,
        addFavourite,
        removeFavourite,
        toggleFavourite,
        isFavourite,
        getFavourites,
        setMyMasjidUsername,
        unsetMyMasjid,
        getMyMasjid,
        isMyMasjid,
      }}
    >
      {children}
    </MasajidContext.Provider>
  );
};
